export const controlStylingConstants = {
  controlHeight: 40,
  menuItemHeight: 32,
  smallMenuItemHeight: 28,
  /** The amount of space to leave to the left of a menu item with no icon to make sure the text aligns with other buttons */
  menuNoIconGutterPadding: 40,
  /** The amount of space between the right edge of a menu item and the edge of the menu */
  menuItemGapToRightEdge: 14,

  splitButtonMenuButtonWidth: 28,

  comboBoxHeight: 28,
  comboBoxCaretWidth: 16,
  comboBoxBorderWidth: 1,
  comboBoxRightMargin: 8,

  comboBoxSmallHeight: 24,
  comboBoxSmallCaretWidth: 12,
  comboBoxSmallRightMargin: 2,

  /** The combined top and bottom padding of combobox */
  comboBoxVerticalPadding: 4,

  /** Minimum CSS pixel diameter required for pointer targets (see WCAG Success Criterion 2.5.8) */
  minTargetSize: 24,
};
